import React, { Suspense, lazy } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

/* loader component for Suspense*/
import PageLoader from './components/Common/PageLoader';

import Base from './components/Layout/Base';
import BasePage from './components/Layout/BasePage';
// import BaseHorizontal from './components/Layout/BaseHorizontal';

/* Used to render a lazy component with react-router */
const waitFor = Tag => props => <Tag {...props}/>;

//RUTAS A ARCHIVOS
const Login = lazy(() => import('./components/CMS_CLIENTE/Login'));
const LoginConsultor = lazy(() => import('./components/CMS_CLIENTE/LoginConsultor'));
const LoginEmpleado = lazy(() => import('./components/CMS_CLIENTE/LoginEmpleado'));
const Recuperar = lazy(() => import('./components/CMS_CLIENTE/Recuperar'));
const Registro = lazy(() => import('./components/CMS_CLIENTE/Registro'));
const Inicio = lazy(() => import('./components/CMS_CLIENTE/Inicio'));
const CambiarContrasena = lazy(() => import('./components/CMS_CLIENTE/CambiarContrasena'));
const MiEmpresa = lazy(() => import('./components/CMS_CLIENTE/MiEmpresa'));
const MisEmpleados = lazy(() => import('./components/CMS_CLIENTE/MisEmpleados'));
const Empleado = lazy(() => import('./components/CMS_CLIENTE/Empleado'));
const AplicarEncuesta = lazy(() => import('./components/CMS_CLIENTE/AplicarEncuesta'));
const ImprimirEncuesta = lazy(() => import('./components/CMS_CLIENTE/ImprimirEncuesta'));
const ResponderEncuesta = lazy(() => import('./components/CMS_CLIENTE/ResponderEncuesta'));
const Encuestas = lazy(() => import('./components/CMS_CLIENTE/Encuestas'));
const VerSetsPreguntas = lazy(() => import('./components/CMS_CLIENTE/VerSetsPreguntas'));
const GuardarSetPreguntas = lazy(() => import('./components/CMS_CLIENTE/GuardarSetPreguntas'));
const VerDetalleEncuesta = lazy(() => import('./components/CMS_CLIENTE/VerDetalleEncuesta'));
const ConfiguracionEncuestas = lazy(() => import('./components/CMS_CLIENTE/ConfiguracionEncuestas'));
const MonitoreoDeEncuestas = lazy(() => import('./components/CMS_CLIENTE/MonitoreoDeEncuestas'));
const MisResultados = lazy(() => import('./components/CMS_CLIENTE/MisResultados'));
const ReportesDeLaNorma = lazy(() => import('./components/CMS_CLIENTE/ReportesDeLaNorma'));
const RNListado = lazy(() => import('./components/CMS_CLIENTE/RNListado'));
const RNEmpleadosAtencionMedica = lazy(() => import('./components/CMS_CLIENTE/RNEmpleadosAtencionMedica'));
const RNFactorRiesgoPsicosocial = lazy(() => import('./components/CMS_CLIENTE/RNFactorRiesgoPsicosocial'));
const RNFactorRiesgoEntorno = lazy(() => import('./components/CMS_CLIENTE/RNFactorRiesgoEntorno'));
const RNReporteOficial = lazy(() => import('./components/CMS_CLIENTE/RNReporteOficial'));
const RNPreguntasExtra = lazy(() => import('./components/CMS_CLIENTE/RNPreguntasExtra'));
const ReportesDeValor = lazy(() => import('./components/CMS_CLIENTE/ReportesDeValor'));
const RVVerEmpleadosConSinRiesgo = lazy(() => import('./components/CMS_CLIENTE/RVVerEmpleadosConSinRiesgo'));
const RVVerEmpleadosPorNivelDeRiesgo = lazy(() => import('./components/CMS_CLIENTE/RVVerEmpleadosPorNivelDeRiesgo'));
const RVVerPreguntasPorCategoriaDominio = lazy(() => import('./components/CMS_CLIENTE/RVVerPreguntasPorCategoriaDominio'));
const RVVerPreguntasRespuestas = lazy(() => import('./components/CMS_CLIENTE/RVVerPreguntasRespuestas'));
const Incidencias = lazy(() => import('./components/CMS_CLIENTE/Incidencias'));
const CentroDeMensajes = lazy(() => import('./components/CMS_CLIENTE/CentroDeMensajes'));
const Avisos = lazy(() => import('./components/CMS_CLIENTE/Avisos'));
const VerPlanAccion = lazy(() => import('./components/CMS_CLIENTE/VerPlanAccion'));
const VerPoliticaRiesgo = lazy(() => import('./components/CMS_CLIENTE/VerPoliticaRiesgo'));
const VerResultadosEmpresa = lazy(() => import('./components/CMS_CLIENTE/VerResultadosEmpresa'));
const Ayuda = lazy(() => import('./components/CMS_CLIENTE/Ayuda'));
const AyudaDescargarDocumentos = lazy(() => import('./components/CMS_CLIENTE/AyudaDescargarDocumentos'));
const AyudaPreguntasFrecuentes = lazy(() => import('./components/CMS_CLIENTE/AyudaPreguntasFrecuentes'));
const AyudaTickets = lazy(() => import('./components/CMS_CLIENTE/AyudaTickets'));
const AyudaChat = lazy(() => import('./components/CMS_CLIENTE/AyudaChat'));

// Paginas publicas (sin sesión)
const listofPages = [
    '/login',
    '/login-consultor',
    '/login-empleado',
    '/registro',
    '/recuperar',
    '/cerrarsesion'
];

const Routes = ({ location }) => {
    const currentKey = location.pathname.split('/')[1] || '/';
    const timeout = { enter: 500, exit: 500 };

    // Animations supported
    //      'rag-fadeIn'
    //      'rag-fadeInRight'
    //      'rag-fadeInLeft'

    const animationName = 'rag-fadeIn'
    var sPathName = (location.pathname).toLowerCase();
    var boolSessionIniciada = false;
    if ( sessionStorage.getItem('iIDEmpresa') != null && sessionStorage.getItem('iIDUsuario') != null) {
      boolSessionIniciada = true;
    }

    if(listofPages.indexOf(sPathName) > -1 ) {
        return (
            // Page Layout component wrapper
            <BasePage>
                <Suspense fallback={<PageLoader/>}>
                    <Switch location={location}>
                        <Route path="/login" component={waitFor(Login)}/>
                        <Route path="/login-consultor" component={waitFor(LoginConsultor)}/>
                        <Route path="/login-empleado" component={waitFor(LoginEmpleado)}/>
                        <Route path="/registro" component={waitFor(Registro)}/>
                        <Route path="/recuperar" component={waitFor(Recuperar)}/>//Reiniciar contraseña de cuenta
                        <Route path="/cerrarsesion" component={waitFor(Login)}/>
                    </Switch>
                </Suspense>
            </BasePage>
        )
    } else if ( !boolSessionIniciada ) {//Si no tiene sesión ingresada, enviar a login
        return (
            <Redirect to="/login" />//Ruta predeterminada
        )
    } else if ( //Verificar permisos
      (sPathName == "/miempresa" && sessionStorage.getItem('iMMiEmpresa') == 0)  ||
      ((sPathName == "/misempleados" || sPathName == "/empleado") && sessionStorage.getItem('iMMisTrabajadores') == 0) ||
      ((sPathName == "/encuestas" || sPathName == "/aplicarencuesta" ||
      sPathName == "/versetspreguntas" || sPathName == "/guardarsetpreguntas") && sessionStorage.getItem('iMEncuestas') == 0) ||
      (sPathName == "/configuracionencuestas" && sessionStorage.getItem('iMConfiguracionEncuestas') == 0) ||
      (sPathName == "/monitoreodeencuestas" && sessionStorage.getItem('iMMonitoreoEncuestas') == 0) ||
      ((sPathName == "/reportesdelanorma" || sPathName == "/rnlistado" ||
      sPathName == "/rnempleadosatencionmedica" || sPathName == "/rnfactorriesgopsicosocial" ||
      sPathName == "/rnfactorriesgoentorno" || sPathName == "/rnreporteoficial" )&& sessionStorage.getItem('iMReportesNorma') == 0) ||
      ((sPathName == "/reportesdevalor" || sPathName == "/rv-empleados-evaluados" || sPathName == "/rv-empleados-por-riesgo" ||
      sPathName == "/rv-preguntas-y-respuestas-por-categoria" || sPathName == "/rv-preguntas-y-respuestas-por-dominio" ||
      sPathName == "/rv-preguntas-y-respuestas") && sessionStorage.getItem('iMReportesValor') == 0) ||
      (sPathName == "/incidencias" && sessionStorage.getItem('iMIncidencias') == 0) ||
      (sPathName == "/centrodemensajes" && sessionStorage.getItem('iMCentroMensajes') == 0) ||
      (sPathName == "/avisos" && (sessionStorage.getItem('iMAvisos') == 0 && sessionStorage.getItem('sTipo') != 'Empleado' )) ||
      (sPathName == "/ayuda" && sessionStorage.getItem('iMAyuda') == 0) ||
      (sPathName == "/misresultados" && sessionStorage.getItem('sTipo') != 'Empleado')  ){
      if ( sessionStorage.getItem('sTipo') == 'Empleado' ) {
        return (
          <Redirect to="/misresultados" />//Redireccionar al inicio si no cuenta con permisos
        )
      }else {
        return (
          <Redirect to="/inicio" />//Redireccionar al inicio si no cuenta con permisos
        )
      }

    }else{

        return (
            // Layout component wrapper
            // Use <BaseHorizontal> to change layout
            <Base>

                <TransitionGroup>
                    <CSSTransition key={currentKey} timeout={timeout} classNames={animationName} exit={false}>
                        <div>
                            <Suspense fallback={<PageLoader/>}>
                                <Switch location={location}>
                                    <Route path="/login" component={waitFor(Login)}/>//Login de empresas registradas
                                    <Route path="/registro" component={waitFor(Registro)}/>//Registrar nueva cuenta
                                    <Route path="/inicio" component={waitFor(Inicio)}/>//Ver resumen general
                                    <Route path="/cambiarcontrasena" component={waitFor(CambiarContrasena)}/>//Cambiar contraseña de usuario
                                    <Route path="/miempresa" component={waitFor(MiEmpresa)}/>//Ver los datos de mi empresa
                                    <Route path="/misempleados" component={waitFor(MisEmpleados)}/>//ver a mis empleados de la empresa
                                    <Route path="/empleado" component={waitFor(Empleado)}/>//Alta editar empleado
                                    <Route path="/aplicarencuesta" component={waitFor(AplicarEncuesta)}/>//Nueva encuesta
                                    <Route path="/imprimir-encuesta" component={waitFor(ImprimirEncuesta)}/>//imprimir encuesta
                                    <Route path="/responder-encuesta" component={waitFor(ResponderEncuesta)}/>//Responder encuesta
                                    <Route path="/encuestas" component={waitFor(Encuestas)}/>//Ver encuestas
                                    <Route path="/versetspreguntas" component={waitFor(VerSetsPreguntas)}/>//Ver sets de preguntas para preguntas extras
                                    <Route path="/guardarsetpreguntas" component={waitFor(GuardarSetPreguntas)}/>//Ingresar nuevas preguntas
                                    <Route path="/verdetalleencuesta" component={waitFor(VerDetalleEncuesta)}/>//Ver detalle de una encuesta
                                    <Route path="/configuracionencuestas" component={waitFor(ConfiguracionEncuestas)}/>//editar ayuda de pregunta de encuesta
                                    <Route path="/monitoreodeencuestas" component={waitFor(MonitoreoDeEncuestas)}/>//Verificar el estatus de las encuestas
                                    <Route path="/misresultados" component={waitFor(MisResultados)}/>
                                    <Route path="/reportesdelanorma" component={waitFor(ReportesDeLaNorma)}/>//Reportes de la norma
                                    <Route path="/rnlistado" component={waitFor(RNListado)}/>//Reportes de la norma listado de encuestas
                                    <Route path="/rnempleadosatencionmedica" component={waitFor(RNEmpleadosAtencionMedica)}/>//Reportes de la norma atención médica
                                    <Route path="/rnfactorriesgopsicosocial" component={waitFor(RNFactorRiesgoPsicosocial)}/>//Reportes de la norma factor riesgo psicosocial
                                    <Route path="/rnfactorriesgoentorno" component={waitFor(RNFactorRiesgoEntorno)}/>//Reportes de la norma factor riesgo entorno
                                    <Route path="/rnreporteoficial" component={waitFor(RNReporteOficial)}/>//Reportes de la norma reporte oficial
                                    <Route path="/rnpreguntasextras" component={waitFor(RNPreguntasExtra)}/>//Reportes de preguntas extra
                                    <Route path="/reportesdevalor" component={waitFor(ReportesDeValor)}/>//Analisis de encuestas
                                    <Route path="/rv-empleados-evaluados" component={waitFor(RVVerEmpleadosConSinRiesgo)}/>//selecionar empleados evaluados
                                    <Route path="/rv-empleados-por-riesgo" component={waitFor(RVVerEmpleadosPorNivelDeRiesgo)}/>//selecionar empleados por nivel de riesgo
                                    <Route path="/rv-preguntas-y-respuestas-por-categoria" component={waitFor(RVVerPreguntasPorCategoriaDominio)}/>//selecionar preguntas y respuestas por categoria
                                    <Route path="/rv-preguntas-y-respuestas-por-dominio" component={waitFor(RVVerPreguntasPorCategoriaDominio)}/>//selecionar preguntas y respuestas por dominio
                                    <Route path="/rv-preguntas-y-respuestas" component={waitFor(RVVerPreguntasRespuestas)}/>//seleccionar preguntas y respuestas (detalle)
                                    <Route path="/incidencias" component={waitFor(Incidencias)}/>//Ver las incidencias reportadas
                                    <Route path="/centrodemensajes" component={waitFor(CentroDeMensajes)}/>//Enviar mensajes a usuarios
                                    <Route path="/avisos" component={waitFor(Avisos)}/>//Crear avisos a usuarios
                                    <Route path="/verplanaccion" component={waitFor(VerPlanAccion)}/>//Plan de accion de la encuesta
                                    <Route path="/verpoliticariesgo" component={waitFor(VerPoliticaRiesgo)}/>//Plan politica de riesgo de la empresa
                                    <Route path="/verresultadosempresa" component={waitFor(VerResultadosEmpresa)}/>//Ver resultados de la empresa

                                    <Route path="/ayuda-descargar" component={waitFor(AyudaDescargarDocumentos)}/>//Ayuda para descargar documentos
                                    <Route path="/ayuda-preguntas-frecuentes" component={waitFor(AyudaPreguntasFrecuentes)}/>//Ayuda preguntas frecuentes
                                    <Route path="/ayuda-tickets" component={waitFor(AyudaTickets)}/>//Ayuda generar tickets
                                    <Route path="/ayuda-chat" component={waitFor(AyudaChat)}/>//Ayuda CHAT
                                    <Route path="/ayuda" component={waitFor(Ayuda)}/>//Ayuda para el usuario CMS

                                    <Redirect to="/login" />//Ruta predeterminada
                                </Switch>
                            </Suspense>
                        </div>
                    </CSSTransition>
                </TransitionGroup>
            </Base>
        )
    }
}

export default withRouter(Routes);
